import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Command, Calendar, CheckSquare, Search, X } from 'lucide-react';

const ShortcutKey = ({ children, variant = 'default' }) => (
  <kbd className={`
    px-2 py-1 rounded font-mono text-sm font-semibold
    ${variant === 'command' 
      ? 'bg-cyan-900/30 text-cyan-300 border border-cyan-600/30' 
      : 'bg-slate-700 text-slate-200 border border-slate-600'
    }
  `}>
    {children}
  </kbd>
);

const ShortcutRow = ({ keys, description, icon: Icon }) => (
  <div className="flex items-center justify-between py-3 border-b border-slate-700 last:border-0">
    <div className="flex items-center gap-3">
      {Icon && <Icon className="w-5 h-5 text-slate-400" />}
      <span className="text-slate-300">{description}</span>
    </div>
    <div className="flex items-center gap-2">
      {keys}
    </div>
  </div>
);

export const KeyboardShortcutsHelp = ({ isOpen, onClose }) => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const modKey = isMac ? '⌘' : 'Ctrl';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-700 text-white max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center gap-3">
            <Command className="w-6 h-6 text-cyan-400" />
            Atajos de Teclado
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6 mt-4">
          {/* Navegación */}
          <div>
            <h3 className="text-lg font-semibold text-cyan-400 mb-3">Navegación</h3>
            <div className="space-y-0">
              <ShortcutRow
                icon={Calendar}
                description="Crear nuevo evento"
                keys={<ShortcutKey>N</ShortcutKey>}
              />
              <ShortcutRow
                icon={CheckSquare}
                description="Crear nueva tarea"
                keys={<ShortcutKey>T</ShortcutKey>}
              />
            </div>
          </div>

          {/* Búsqueda */}
          <div>
            <h3 className="text-lg font-semibold text-cyan-400 mb-3">Búsqueda</h3>
            <div className="space-y-0">
              <ShortcutRow
                icon={Search}
                description="Búsqueda global"
                keys={
                  <>
                    <ShortcutKey variant="command">{modKey}</ShortcutKey>
                    <span className="text-slate-500">+</span>
                    <ShortcutKey>K</ShortcutKey>
                  </>
                }
              />
              <ShortcutRow
                icon={Search}
                description="Focus en buscador"
                keys={<ShortcutKey>/</ShortcutKey>}
              />
            </div>
          </div>

          {/* General */}
          <div>
            <h3 className="text-lg font-semibold text-cyan-400 mb-3">General</h3>
            <div className="space-y-0">
              <ShortcutRow
                icon={Command}
                description="Mostrar esta ayuda"
                keys={<ShortcutKey>?</ShortcutKey>}
              />
              <ShortcutRow
                icon={X}
                description="Cerrar modales"
                keys={<ShortcutKey>Esc</ShortcutKey>}
              />
            </div>
          </div>

          {/* Tip */}
          <div className="mt-6 p-4 bg-cyan-900/20 border border-cyan-600/30 rounded-lg">
            <p className="text-sm text-slate-300">
              <span className="font-semibold text-cyan-400">💡 Tip:</span> Los atajos no funcionan cuando estás escribiendo en un campo de texto.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KeyboardShortcutsHelp;
